import * as common from 'store/modules/common'
import { api } from './api'
import { actionTypes as notificationTypes } from 'store/modules/notifications'

export const prefix = 'backgroundActions'

export { api }
export const initialState = { ...common.initialState, entity: [] }
export const actionTypes = {
  ...common.actionTypes(prefix)
}
export const actionCreators = {
  ...common.actionCreators(prefix, api)
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case notificationTypes.updateBackgroundAction: return { ...state, entity: state.entity.map(x => {
      if (x.id === action.payload.id) {
        return { ...x, ...action.payload }
      }
      return x
    }) }
    default: return common.reducer(state, action, prefix)
  }
}
